<template>
  <div v-if="visible" class="uom-mask">
    <div class="uom-modal">
      <div class="uom-header">
        <svg-icon icon-class="icon_zhuyi" class-name="c-F53F3F" />
        <span class="uom-title">无法禁用该员工</span>
        <i class="el-icon-close uom-close" @click="close" />
      </div>
      <div class="uom-subtitle">
        员工「{{ userName }}」存在
        <em class="uom-count">{{ displayItems.length }}</em>
        项未解除的业务占用，禁用前需先处理以下事项：
      </div>
      <div class="uom-list-header">
        <span>占用明细（{{ displayItems.length }} 条）</span>
        <!-- <span class="uom-resolved">已解除: 0/{{ items.length }}</span> -->
      </div>
      <div class="uom-list">
        <div v-for="(item, idx) in displayItems" :key="idx" class="uom-item">
          <div class="uom-item-main">
            <div class="uom-item-num">{{ idx + 1 }}</div>
            <div class="uom-item-body">
              <div class="uom-item-title">
                <span class="uom-type-label">{{ item.typeLabel || '业务占用' }}</span>
                <span v-if="item.manageName" class="uom-manage-link" @click="goManage(item)">{{ item.manageName }}</span>
              </div>
              <!-- 聚合格式(DELIVERY_IN_PROGRESS 聚合后):直接渲染后端拼接好的 title -->
              <template v-if="isAggregateItem(item)">
                <!-- DELIVERY_ASSISTANT 的数量已在 handleMethod "为名下 N 名学员更换助教" 中体现,这里不再重复展示 title -->
                <div v-if="item.type !== 'DELIVERY_ASSISTANT'" class="uom-item-row">
                  <span class="uom-row-value uom-aggregate-title">{{ item.title }}</span>
                </div>
                <div class="uom-item-row uom-handle-method">
                  <span class="uom-row-label">处理方式：</span>
                  <span class="uom-row-value">{{ item.handleMethod || 'TODO: 暂未提供处理方式' }}</span>
                </div>
              </template>
              <!-- 单条格式:按字段渲染 -->
              <template v-else>
                <!-- TEACHING_ASSISTANT_ONLY: title 字段已是自描述完整格式("IP：xxx  兜底助教：xxx"),直接渲染不再加前缀 -->
                <!-- DELIVERY_HEADTEACHER 的 "学员数：N 人" 已在 handleMethod "为名下 N 名学员更换班主任" 中体现,这里不再重复展示 -->
                <div v-if="item.type === 'TEACHING_ASSISTANT_ONLY'" class="uom-item-row">
                  <span class="uom-row-value">{{ item.title }}</span>
                </div>
                <!-- SALE_USER_OCCUPANCY / DELIVERY_HEADTEACHER / DELIVERY_ASSISTANT: 不展示 rowTitleLabel+title 行(只留处理方式);
                     DELIVERY_HEADTEACHER 的 "学员数：N 人"、DELIVERY_ASSISTANT 的 "名下学员：共 N 名" 都是冗余数量展示,跟 handleMethod 重复 -->
                <div v-else-if="item.type !== 'SALE_USER_OCCUPANCY' && item.type !== 'DELIVERY_HEADTEACHER' && item.type !== 'DELIVERY_ASSISTANT'" class="uom-item-row">
                  <span class="uom-row-label">{{ rowTitleLabel(item) }}：</span>
                  <span class="uom-row-value">{{ item.title || '—' }}</span>
                  <template v-if="item.itemId && item.type !== 'DELIVERY_HEADTEACHER' && item.type !== 'FEISHU_REMINDER'">
                    <span class="uom-row-divider" />
                    <span class="uom-row-label">任务ID：</span>
                    <span class="uom-row-value">{{ item.itemId }}</span>
                  </template>
                </div>
                <!-- 附加列表(班主任场景展示订单号列表) -->
                <div v-if="item.extraList && item.extraList.length" class="uom-extra-list">
                  <div v-for="(line, i) in item.extraList" :key="i" class="uom-extra-row">
                    <span class="uom-row-value">{{ line }}</span>
                  </div>
                </div>
                <div v-if="shouldShowRelatedUser(item)" class="uom-item-row">
                  <span class="uom-row-label">{{ relatedUserLabel(item) }}：</span>
                  <span class="uom-row-value">{{ item.relatedUserName }}</span>
                </div>
                <div class="uom-item-row uom-handle-method">
                  <span class="uom-row-label">处理方式：</span>
                  <span class="uom-row-value">{{ item.handleMethod || 'TODO: 暂未提供处理方式' }}</span>
                </div>
              </template>
            </div>
          </div>
          <!-- 聚合格式:固定显示"批量更换助教"蓝色按钮(不依赖 handleUrl) -->
          <el-button
            v-if="isAggregateItem(item)"
            type="primary"
            size="small"
            class="uom-go-btn"
            @click="handleGo(item)"
          >批量更换助教</el-button>
          <!-- 单条格式:按钮一直显示,具体跳哪个页面在前端按 type 路由 -->
          <el-button
            v-else
            type="primary"
            size="small"
            class="uom-go-btn"
            @click="handleGo(item)"
          >去处理</el-button>
        </div>
      </div>
      <div class="uom-footer">
        <el-button size="small" @click="close">我知道了</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserOccupancyModal',
  data() {
    return {
      visible: false,
      userName: '',
      items: []
    }
  },
  computed: {
    // 文案归一化:
    // 1) DELIVERY_HEADTEACHER:与 DELIVERY_ASSISTANT 句式对齐 → "前往【学员管理】为名下 N 名学员更换班主任",N 从 item.title 中提取
    // 2) SALE_USER_OCCUPANCY:后端会按任务逐条回传多条,前端聚合成 1 条(只展示首条),避免弹窗里重复刷出多条「智能销售任务接待人」
    // 3) 其他情况:兜底把后端 handleMethod 里的【学员列表】统一为【学员管理】,与 item.manageName 保持一致
    displayItems() {
      const arr = Array.isArray(this.items) ? this.items : []
      // SALE_USER_OCCUPANCY 聚合:多条 → 1 条,其他类型保持原样
      const dedupArr = []
      let saleKept = false
      for (const it of arr) {
        if (!it) continue
        if (it.type === 'SALE_USER_OCCUPANCY') {
          if (!saleKept) {
            dedupArr.push(it)
            saleKept = true
          }
          // 后续 SALE_USER_OCCUPANCY 直接丢弃
        } else {
          dedupArr.push(it)
        }
      }
      // FEISHU_REMINDER 兜底过滤:后端 typeLabel 在某些类型(目前已知 7、8)只回传了枚举数字,
      // title 拼接出来就是纯数字"7"/"8",渲染成"提醒设置:7"看起来像没内容;先在前端过滤掉避免误导。
      // 等后端 typeLabel 改成中文 label 后再去掉这段过滤。
      const filteredArr = dedupArr.filter(it => {
        if (it && it.type === 'FEISHU_REMINDER' && (it.title === '7' || it.title === '8')) {
          return false
        }
        return true
      })
      return filteredArr.map(it => {
        const next = { ...it }
        if (it && it.type === 'DELIVERY_HEADTEACHER') {
          // 数量已在 title 行隐藏后的视觉补偿中体现(或者已经在前端 Web 端做别的展示),
          // 这里只保留静态文案,不再嵌入 "为名下 N 名学员" 这种带数字的描述
          next.handleMethod = '前往【学员管理】为名下学员更换班主任'
        } else if (it && typeof it.handleMethod === 'string') {
          // 兜底:DELIVERY_ASSISTANT 后端文案形如 "前往【学员管理】为名下 5 名学员更换助教",
          // 等 edata-user 部署上线后,后端会改成 "前往【学员管理】为名下学员更换助教";在此之前
          // 前端先把 "为名下 [N] 名学员" 这段剥掉,无论后端新旧版都收敛成同一展示
          if (it.type === 'DELIVERY_ASSISTANT') {
            next.handleMethod = it.handleMethod.replace(/为名下\s*\d*\s*名?学员?/, '为名下学员')
          } else {
            next.handleMethod = it.handleMethod.replace(/【学员列表】/g, '【学员管理】')
          }
        }
        // TEACHING_ASSISTANT_ONLY:后端 title 形如 "IP：aaa015,关苏哲 兜底助教：何涵2",
        // 原生空格视觉上贴得太近,把 "兜底助教" 前面的空白换成全角空格,让 IP / 兜底助教两个字段明显分开
        if (it && it.type === 'TEACHING_ASSISTANT_ONLY' && typeof it.title === 'string') {
          next.title = it.title.replace(/\s+兜底助教/g, '　　兜底助教')
        }
        return next
      })
    }
  },
  watch: {
    // 弹窗打开期间锁住 body 滚动,避免在遮罩内滚轮把背景页面也带着滑
    visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  beforeDestroy() {
    // 组件销毁兜底释放 body 锁,避免路由切换等场景下样式残留
    document.body.style.overflow = ''
  },
  methods: {
    close() {
      this.visible = false
    },
    handleGo(item) {
      // 优先用后端 handleUrl;前端不再拼具体路径,具体跳转 URL 由用户后续在 buildHandleUrl 中按 type 配置
      let url = item.handleUrl || ''
      if (!url) {
        url = this.buildHandleUrl(item)
      }
      if (!url) return
      const openType = item.handleOpenType || 'tab'
      if (openType === 'route') {
        window.location.hash = url.replace(/^#/, '')
      } else {
        window.open(window.location.origin + url, '_blank')
      }
    },
    // 按 type 拼处理页 URL
    buildHandleUrl(item) {
      if (!item) return ''
      const t = item.type || ''
      // FEISHU_REMINDER: 按提醒设置具体内容跳不同页
      // - 学员在第三方店铺申请退款 → 售后通用设置 - 通知设置
      // - 其他提醒设置(续期提醒等) → 飞书提醒设置
      if (t === 'FEISHU_REMINDER') {
        const reminderTitle = (item.title || '').trim()
        if (reminderTitle === '学员在第三方店铺申请退款') {
          return '/#/afterSale/generalSetting/inform'
        }
        return '/#/oaManagement/generalSettings/reminderSettings'
      }
      // TEACHING_ASSISTANT_ONLY: 跳线下课分配设置,带 IP id + 课程类型预筛
      if (t === 'TEACHING_ASSISTANT_ONLY') {
        const params = []
        if (item.ipTeacherIds) {
          // ipTeacherIds 可能是 "id1,id2,id3" / 数组 / 单个;目标页 IP 输入框是 el-select,
          // 只能展示一个讲师,这里统一只取第一个,避免多 id 时 el-select 显示成第一个 id 字符串
          // (第一个 id 在 teacherOptions 里匹配不上时无可读 label)
          const firstIpId = String(item.ipTeacherIds).split(',')[0].trim()
          if (firstIpId) {
            params.push('ipIds=' + encodeURIComponent(firstIpId))
          }
        }
        // 从后端给的中文 title("IP:张三 兜底助教:李四")里拆出 IP 名,
        // 用于目标页 teacher-select 的 setDefaultValue() 反查 option
        // 注意:title 里 IP 名后面会用 `,` 拼上兜底助教名(如 "IP:aaa015,关容忍 兜底助教:李四"),
        // 所以负向字符类里必须包含 `,`,否则会把 ",关容忍" 一起吞进 ipName,
        // 导致下游 lecturerName 模糊搜索因长度不一致匹配不上、el-select 退化成显示 raw id
        if (item.title) {
          const m = item.title.match(/IP[：:]\s*([^,，\s兜底]+)/)
          if (m && m[1]) {
            params.push('ipName=' + encodeURIComponent(m[1].trim()))
          }
        }
        if (item.courseType != null) {
          params.push('curriculumType=' + item.courseType)
        }
        const qs = params.length ? '?' + params.join('&') : ''
        return '/#/deliver/allocations' + qs
      }
      // DELIVERY_HEADTEACHER: 班级助教/班主任 → 跳全部学员页,带班主任姓名 + 未完结交付状态预筛
      if (t === 'DELIVERY_HEADTEACHER') {
        const params = ['deliveryStatusList=1,2,3,4']
        if (item.relatedUserName) {
          params.push('headteacherUserName=' + encodeURIComponent(item.relatedUserName))
        }
        const qs = '?' + params.join('&')
        return '/#/deliver/studentManagement/offline/studentManagementAllStudent' + qs
      }
      // DELIVERY_ASSISTANT: 学员助教 → 跳全部学员页,带助教姓名 + 未完结交付状态预筛
      if (t === 'DELIVERY_ASSISTANT') {
        const params = ['deliveryStatusList=1,2,3,4']
        if (item.relatedUserName) {
          params.push('assistantUserName=' + encodeURIComponent(item.relatedUserName))
        }
        const qs = '?' + params.join('&')
        return '/#/deliver/studentManagement/offline/studentManagementAllStudent' + qs
      }
      // SALE_USER_OCCUPANCY: 销售任务 → 跳任务兜底设置页
      if (t === 'SALE_USER_OCCUPANCY') {
        return '/#/privateArea/revealTask'
      }
      return ''
    },
    goManage(item) {
      this.handleGo(item)
    },
    // 判断是否为聚合格式 item(后端 title 含"共 N 名")
    isAggregateItem(item) {
      return item && item.title && item.title.indexOf('共') !== -1 && item.title.indexOf('名') !== -1
    },
    // 单条 item 标题字段标签(按 type 区分)
    rowTitleLabel(item) {
      if (!item) return '任务名称'
      const t = item.type || ''
      if (t === 'TEACHING_ASSISTANT_ONLY') return '课程'
      if (t === 'FEISHU_REMINDER') return '提醒设置'
      if (t === 'SALE_USER_OCCUPANCY') return '销售任务'
      if (t === 'DELIVERY_HEADTEACHER') return '班期'
      if (t === 'DELIVERY_IN_PROGRESS') return '订单'
      return '任务名称'
    },
    // relatedUserName 行的标签(按 type 区分)
    relatedUserLabel(item) {
      if (!item) return '接待人'
      const t = item.type || ''
      // FEISHU_REMINDER 上下文是提醒设置,这里展示的是"被提醒人",标签用"提醒人"更贴切
      if (t === 'FEISHU_REMINDER') return '提醒人'
      return '接待人'
    },
    // 是否渲染"接待人"行:TEACHING_ASSISTANT_ONLY / DELIVERY_HEADTEACHER / DELIVERY_ASSISTANT 三类
    // 的 relatedUserName 都是被禁用员工本人,仅供 URL 跳转筛选用,不需要在弹窗里重复展示
    shouldShowRelatedUser(item) {
      if (!item || !item.relatedUserName) return false
      const t = item.type || ''
      if (t === 'TEACHING_ASSISTANT_ONLY') return false
      if (t === 'DELIVERY_HEADTEACHER') return false
      if (t === 'DELIVERY_ASSISTANT') return false
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.uom-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.uom-modal {
  width: 720px;
  max-height: 80vh;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.uom-header {
  display: flex;
  align-items: center;
  padding: 18px 24px;
  background: #fafbfc;
  border-bottom: 1px solid #f0f0f0;

  .svg-icon {
    font-size: 22px;
    color: #f53f3f;
    margin-right: 10px;
  }

  .uom-title {
    font-size: 16px;
    font-weight: 600;
    color: #353535;
    flex: 1;
  }

  .uom-close {
    font-size: 18px;
    color: #909399;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #105cfb;
    }
  }
}

.uom-subtitle {
  padding: 16px 24px 8px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;

  .uom-count {
    color: #f53f3f;
    font-weight: 600;
    font-style: normal;
    margin: 0 2px;
  }
}

.uom-list-header {
  padding: 4px 24px 8px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #606266;

  .uom-resolved {
    color: #909399;
  }
}

.uom-list {
  padding: 0 24px 8px;
  overflow-y: auto;
  max-height: 50vh;
}

.uom-item {
  display: flex;
  align-items: stretch;
  border: 1px solid #f0f0f0;
  border-left: 3px solid #f53f3f;
  border-radius: 4px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #fff;

  &:last-child {
    margin-bottom: 0;
  }

  .uom-item-main {
    flex: 1;
    display: flex;
  }

  .uom-item-num {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f53f3f;
    color: #fff;
    font-size: 13px;
    line-height: 24px;
    text-align: center;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .uom-item-body {
    flex: 1;
    min-width: 0;
  }

  .uom-item-title {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .uom-type-label {
      font-size: 14px;
      font-weight: 600;
      color: #353535;
    }

    .uom-manage-link {
      margin-left: 10px;
      font-size: 12px;
      color: #105cfb;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .uom-item-row {
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .uom-row-label {
      color: #909399;
      margin-right: 4px;
    }

    .uom-row-value {
      color: #353535;
    }

    .uom-row-divider {
      width: 1px;
      height: 12px;
      background: #e4e7ed;
      margin: 0 10px;
    }
  }

  .uom-handle-method {
    margin-top: 2px;
  }

  .uom-extra-list {
    margin-top: 4px;
    padding: 6px 10px;
    background: #fafafa;
    border-radius: 4px;
    max-height: 160px;
    overflow-y: auto;
  }

  .uom-extra-row {
    font-size: 12px;
    line-height: 1.7;
    color: #353535;
    word-break: break-all;
  }

  .uom-go-btn {
    align-self: center;
    margin-left: 16px;
    flex-shrink: 0;
  }
}

.uom-footer {
  display: flex;
  justify-content: flex-end;
  padding: 14px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafbfc;
}
</style>